const clean = value => {
  try {
    return JSON.parse(JSON.stringify(value, (key, val) => {
      if (typeof val === 'function') return undefined;
      if (typeof key === 'string' && key.startsWith('$$')) return undefined;
      return val;
    }));
  } catch (e) {
    return String(value);
  }
};

const salesEvents = {
  entries: [],

  add(type, name, data = {}) {
    this.entries.push({
      timestamp: new Date().toISOString(),
      type,
      name,
      data: clean(data),
    });
  },

  log() {
    console.table(this.entries.map(e => ({
      time: e.timestamp.split('T')[1].replace('Z', ''),
      type: e.type,
      name: e.name,
      data: JSON.stringify(e.data),
    })));
  },

  clear() {
    this.entries = [];
  },
};

if (typeof window !== 'undefined') {
  window.salesEvents = salesEvents;
}

export default salesEvents;
